import styled from "styled-components";

export const LockedBonusCardRootDiv = styled.div`
    width: 96%;
    border: 1px solid #2C5391;
    height: 6.25rem;
    border-radius: 0.5rem;
    background: #E9ECF0;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;


`
export const BonusDiv = styled.div`
    color: #032146;
    font-weight: 900;
    font-size: 1.25rem;
    display: flex;
    margin-left: 1rem;

`

export const BonusAmountDiv = styled.div`
    display: flex;
    flex-direction: column;
    margin-left: 0.5rem;

`
export const BonusDescription = styled.div`
    font-size: 0.75rem;
    font-weight: 400;
`
